import { useEffect, useRef, useState } from 'react'
import { useStore } from '../state/store'
import { IdPad } from './IdPad'
import { Sheet } from './Sheet'
import { readDay } from '../state/day'
import type { Employee } from '../lib/types'

/** Signing: whoever opened the store for the day signs everyday actions automatically (their ID is already on the day).
 *  The pad only appears when an owner's ID is required (below-floor approval, void, reopen, Team), or when no day is open. */
export function SignSheet({ title = 'Sign with your ID', ownerOnly, onConfirm, onClose, busy }: { title?: string; ownerOnly?: boolean; onConfirm: (e: Employee) => void; onClose: () => void; busy?: boolean }) {
  const { employees } = useStore()
  const fired = useRef(false)
  const [auto] = useState(() => {
    if (ownerOnly) return null
    const d = readDay()
    const e = d ? employees.find((x) => x.employee_id === d.employee_id && x.active) : undefined
    return e ?? null
  })
  useEffect(() => {
    if (auto && !fired.current) { fired.current = true; onConfirm(auto) }
  }, [auto, onConfirm])
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey); return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  if (auto) return null
  return (
    <Sheet onClose={onClose} label={title}>
      <div className="sheet__title">{title}</div>
      <IdPad employees={employees} ownerOnly={ownerOnly} onConfirm={onConfirm} busy={busy} />
    </Sheet>
  )
}
